import React from 'react';
import { Link } from 'react-router-dom';
import LinkedinIcon from '../assets/icons/linkedin.svg';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className=" flex items-center justify-center">
                <img src="/images/G_colored.png" alt="Gyaanly" className="w-10 h-10" />
              </div>
              <span className="text-xl font-bold">Gyaanly</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              The ultimate platform for creators to build passive income through online courses. 
              Join thousands of successful creators earning while teaching.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/gyaanly" target="_blank" className="text-gray-400 hover:text-white transition-colors  w-6 h-6 duration-200">
                <img src="/images/linkedin.svg" alt="Linkedin" className="w-6 h-6 " />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Early Access</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/early-access" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Register for Early Access
                </Link>
              </li>
            </ul>
          </div>
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">For Learners</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/learn" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Browse Courses
                </Link>
              </li>
            </ul>
          </div> */}
           <div>
            <h3 className="text-lg font-semibold mb-4">For Creators</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/creator" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Creator
                </Link>
              </li>
              <li>
                <Link to="/learn" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Learners
                </Link>
              </li>
              <li></li>
            </ul>
          </div>

          {/* Creator Links */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">For Creators</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/creator" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Creator Platform
                </Link>
              </li>
            </ul>
          </div> */}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-6 mb-4 md:mb-0">
              <span className="text-gray-400">Privacy Policy</span>
              <span className="text-gray-400">Terms of Service</span>
              <span className="text-gray-400">Cookie Policy</span>
            </div>
            <p className="text-gray-400">
              © 2025 Gyaanly. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 